<div style="padding: 40px; min-height: 300px;" class="flex justify-center items-center flex-col relative">

    <button class="absolute top-2 right-2 p-2 hover:bg-gray-100 rounded-full" (click)="handleCloseDialog()">
        <i class="pi pi-times"></i>
    </button>

    <!-- Header Message -->
    <div class="text-center mb-6">
        <h3 class="text-xl font-semibold text-gray-800 mb-2">Bulk Import Dialing Group</h3>
        <p class="text-gray-600 mb-4">Upload your CSV file to import multiple contacts at once</p>

        <!-- Download Sample CSV Button -->
        <button pButton label="Download Sample CSV" icon="pi pi-download" class="p-button-outlined p-button-info mb-4"
            (click)="downloadSampleCSV()">
        </button>
    </div>

    <!-- File upload section -->
    <div class="text-center drop-zone" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
      <p-fileUpload
  #fileUpload
  name="csvFile"
  accept=".csv"
  [customUpload]="true"
  [showUploadButton]="false"
  [showCancelButton]="false"
  [maxFileSize]="1000000"
  chooseLabel="Select CSV File"
  (onSelect)="onFileSelect($event)"
  (onClear)="onFileClear()"
  (onRemove)="onFileRemove($event)"
  [style]="{
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    paddingBottom: '25px',
    paddingTop: '5px'
  }"
  class="mb-4 custom-upload"
>
  <ng-template pTemplate="content">
    <ng-container *ngIf="!csvFile">
      <div
        class="flex flex-column align-items-center"
        style="text-align: center; display: flex; width: 100%; justify-content: center; align-items: center; flex-direction: column; padding: 25px 80px;"
      >
        <i class="pi pi-file-import text-4xl mb-2"></i>
        <div class="upload-text">
          Drag and drop your CSV file here<br />
          <span class="text-sm text-gray-500">or click to browse</span>
        </div>
      </div>
    </ng-container>
  </ng-template>
</p-fileUpload>


        <!-- Upload button -->
        <button pButton label="Upload Data" icon="pi pi-upload" class="p-button-success mt-3" (click)="uploadFile()"
            [loading]="btnLoading" [disabled]="btnLoading || !csvFile">
        </button>
    </div>
</div>